import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { fetchLibraryClaims } from '../../api/library';
import LibraryApprovalEmblem from './LibraryApprovalEmblem';
import '../LibraryPages.css';

export default function LibraryApprovalCard({ schoolId }) {
  const navigate = useNavigate();
  const [count, setCount] = useState(null);
  const [error, setError] = useState('');
  const [retry, setRetry] = useState(0);
  const refresh = useCallback(() => setRetry((value) => value + 1), []);

  useEffect(() => {
    if (!schoolId) return undefined;
    let active = true;
    setError('');
    setCount(null);
    // The unfiltered endpoint is scoped to all of the teacher's allowed classes.
    fetchLibraryClaims(schoolId).then((data) => {
      if (active) setCount(data.items.length);
    }).catch((err) => {
      if (active) setError(err.message || 'Kitap onayları yüklenemedi.');
    });
    return () => { active = false; };
  }, [schoolId, retry]);

  useEffect(() => {
    window.addEventListener('focus', refresh);
    return () => window.removeEventListener('focus', refresh);
  }, [refresh]);

  if (!schoolId || count === 0) return null;
  if (error) return <Alert severity="error" action={<Button color="inherit" onClick={refresh}>Tekrar Dene</Button>}>{error}</Alert>;
  if (count === null) return <Skeleton variant="rounded" height={112} sx={{ borderRadius: 4 }} aria-label="Kitap onayları yükleniyor" />;

  return (
    <Paper className="library-approval-card">
      <LibraryApprovalEmblem count={count} />
        <Box sx={{ minWidth: 0 }}>
          <Box className="library-approval-card__heading">
            <Typography component="h2">Kitap Onayları</Typography>
            <Chip className="library-pending-count" icon={<ScheduleRoundedIcon />} label={`${count} bekliyor`} />
          </Box>
          <Typography className="library-approval-card__description">Öğrencilerinizin tamamladığını bildirdiği kitaplar onayınızı bekliyor.</Typography>
        </Box>
      <Button className="library-primary library-approval-card__cta" variant="contained" endIcon={<ArrowForwardIcon />} onClick={() => navigate('/admin/ogrenci-kutuphanesi/kitap-onaylari')}>Kitapları İncele</Button>
    </Paper>
  );
}
